import React from 'react';
//import { NavLink } from 'react-router-dom';
import './index.css';
import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';
import { ReactComponent as DashboardIcon } from './icons/dashboard.svg';
import { ReactComponent as ContactsIcon } from 'common/icons/contacts.svg';
import { ReactComponent as ServicesIcon } from './icons/services.svg';
import { ReactComponent as CollaborationsIcon } from './icons/collaborations.svg';
import { ReactComponent as FilesIcon } from 'common/icons/files.svg';
import { ReactComponent as ApplicationsIcon } from 'common/icons/four-grid.svg';
import { ReactComponent as SettingsIcon } from './icons/settings.svg';
import { ReactComponent as MonitorIcon } from './icons/monitor.svg';
import { Switch, Tooltip } from '@mui/material';
import { useAuth } from 'common/context/AuthContext';

const SidebarWrapper = styled.div`
    width:72px;
    height:100vh;
    border-right: 1px solid ${(props) => props.theme.colors.primaryTextColor === '#040D2D' ? props.theme.colors.gray : 'transparent'};
    position:fixed;
    top:0;
    left:0;
    display:flex;
    flex-direction: column;
    background-color: ${(props) => props.theme.colors.secondaryBackgroundColor};
    align-items: center;
    padding-top:72px;
    gap:32px;
    z-index: 50;
    
`;

export default function Sidebar({ isLightTheme, setThemePicked }: { isLightTheme:boolean; setThemePicked: React.Dispatch<React.SetStateAction<boolean>> }) {
  const { companyId } = useAuth();
  return (
        <SidebarWrapper>
            <Tooltip title='Акаунт' placement='right'>
                <NavLink className="sidebar-item" to={`/${companyId}`}>
                  <MonitorIcon className='svg-black' />
                </NavLink>
            </Tooltip>
            <Tooltip title='Панель управління' placement='right'>
                <NavLink className="sidebar-item" to='/dashboard'>
                  <DashboardIcon className='svg-black' />
                </NavLink>
            </Tooltip>
            <Tooltip title='Контакти' placement='right'>
                <NavLink className="sidebar-item" to='/contacts'>
                  <ContactsIcon className='svg-black' />
                </NavLink>
            </Tooltip>
            <Tooltip title='Операції' placement='right'>
                <NavLink className="sidebar-item" to='/services'>
                  <ServicesIcon className='svg-black' />
                </NavLink>
            </Tooltip>
            <Tooltip title='Колаборації' placement='right'>
                <NavLink className="sidebar-item" to='/collaborations'>
                  <CollaborationsIcon className='svg-black' />
                </NavLink>
            </Tooltip>
            <Tooltip title='Файли' placement='right'>
                <NavLink className="sidebar-item" to='/files'>
                  <FilesIcon className='svg-black' />
                </NavLink>
            </Tooltip>
            <Tooltip title='Додатки' placement='right'>
                <NavLink className="sidebar-item" to='/applications'>
                  <ApplicationsIcon className='svg-black' />
                </NavLink>
            </Tooltip>
            <Tooltip title='Параметри' placement='right'>
                <NavLink className="sidebar-item" to='/settings'>
                  <SettingsIcon className='svg-black' />
                </NavLink>
            </Tooltip>
            <div style={{ display:'none' }} className='sidebar-switch-wrapper'>
              <Switch size='small' sx={{
                '&:not(.Mui-checked) .MuiSwitch-track': {
                  backgroundColor: '#5678FF',
                },
              }} checked={isLightTheme} onChange={()=>{setThemePicked(!isLightTheme);}} />
            </div>
        </SidebarWrapper>
  );
}